module.exports = __webpack_public_path__ + "static/media/react.240b74b4.png";